module.exports = __webpack_public_path__ + "static/media/pen-nib.8cd40902.svg";